import "../CSS/Background.css";
import React, { useState, useEffect } from "react";
import Icon from "@mdi/react";
import Preload from "./Preload";
import {
  mdiClipboardAccount,
  mdiBriefcaseOutline,
  mdiMapMarker,
  mdiMapMarkerRadius,
  mdiCodeBraces,
  mdiPencilRuler,
  mdiFaceAgent,
  mdiAccountGroup,
} from "@mdi/js";
import parse from "html-react-parser";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import axios from "axios";
import { useLoadingContext } from "../context/LoadingContext";

const apiUrl = process.env.REACT_APP_API_URL;

const Path_Carrusel = require.context("../Images", true);
const Images_src = [
  "./client_1.png",
  "./client_2.png",
  "./client_3.png",
  "./client_4.png",
].map((item) => Path_Carrusel(item));

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
};

function Acerca_de_mi() {
  const [about, setAbout] = useState({ about: "" });
  const [isLoading, setIsLoading] = useState(true);
  const { register, done } = useLoadingContext();

  useEffect(() => {
    register();
    axios
      .get(apiUrl + "about")
      .then((response) => {
        setAbout(response.data[0]);
        setIsLoading(false);
      })
      .catch(console.error)
      .finally(done);
  }, [done, register]);

  if (isLoading) {
    return <Preload />;
  }

  return (
    <div id="about_me" className="content_box">
      <h1 className="content_box_title">
        <Icon path={mdiClipboardAccount} className="Main_Icons" size={1} />
        Acerca de mi
      </h1>
      <div className="box_p">{about && parse(about.about)}</div>

      <ul className="content_box_list">
        <li>
          <Icon path={mdiBriefcaseOutline} className="Main_Icons" size={1} />
          <span>
            <b>{about.location}</b>
          </span>
        </li>
        <li>
          <Icon path={mdiMapMarker} className="Main_Icons" size={1} />
          <span>
            <b>Residente:</b> {about.country}
          </span>
        </li>
        <li>
          <Icon path={mdiMapMarkerRadius} className="Main_Icons" size={1} />
          <span>
            <b>Dirección:</b> {about.city}
          </span>
        </li>
      </ul>
      <h1 className="content_box_title">
        <Icon path={mdiFaceAgent} className="Main_Icons" size={1} />
        <span>
          <b>Mis servicios</b>
        </span>
      </h1>
      <ul className="content_box_list">
        <li className="content_box_sub_title">
          <Icon path={mdiPencilRuler} className="Main_Icons" size={1} />
          <span>
            <b>DISEÑO DE PÁGINAS WEB</b>
          </span>
        </li>
        <li className="content_box_text">
          Un diseño actual, limpio y estructurado te ayudará a conseguir nuevos
          clientes en internet.
        </li>
        <li className="content_box_sub_title">
          <Icon path={mdiCodeBraces} className="Main_Icons" size={1} />
          <span>
            <b>PROGRAMACIÓN WEB A MEDIDA</b>
          </span>
        </li>
        <li className="content_box_text">
          Desarrollo a medida de cualquier herramienta online que necesites
          tener en tu página web.
        </li>
      </ul>
      <h1 className="content_box_title">
        <Icon path={mdiAccountGroup} className="Main_Icons" size={1} />
        <span>
          <b>Clientes</b>
        </span>
      </h1>
      <div className="content_box_carrusel">
        <Slider {...sliderSettings}>
          {Images_src.map((src, index) => (
            <div key={index}>
              <img
                className="content_box_carrusel_img"
                src={src}
                alt={`cliente-${index + 1}`}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Acerca_de_mi;
